export const banks = [
  { label: "Absa Bank", value: "absa" },
  { label: "African Bank", value: "african_bank" },
  { label: "Capitec Bank", value: "capitec" },
  { label: "Discovery Bank", value: "discovery" },
  { label: "FNB (First National Bank)", value: "fnb" },
  { label: "Investec Bank", value: "investec" },
  { label: "Nedbank", value: "nedbank" },
  { label: "Standard Bank", value: "standard_bank" },
  { label: "TymeBank", value: "tymebank" },
  { label: "Bidvest Bank", value: "bidvest" },
  { label: "Mercantile Bank", value: "mercantile" },
  { label: "Other", value: "other" },
  //   { label: "Ubank", value: "ubank" },
  //   { label: "Bank Zero", value: "bank_zero" },
  //   { label: "Al Baraka Bank", value: "al_baraka" },
  //   { label: "HBZ Bank", value: "hbz" },
  //   { label: "Grobank (Bank of Athens)", value: "grobank" },
];

export const payfastBanks = [
  { bank_name: "", label: "--Select--" },
  {
    bank_name: "ABSA",
    label: "Absa",
  },
  {
    bank_name: "STANDARD",
    label: "Standard Bank",
  },
  {
    bank_name: "FNB",
    label: "FNB",
  },
  {
    bank_name: "NEDBANK",
    label: "Nedbank",
  },
  {
    bank_name: "INVESTEC",
    label: "Investec",
  },
  {
    bank_name: "GOBANKING",
    label: "Go Banking",
  },
  {
    bank_name: "OLDMUTUAL",
    label: "Old Mutual Bank",
  },
  {
    bank_name: "RMB",
    label: "RMB Private Bank",
  },
  {
    bank_name: "CAPITEC",
    label: "Capitec Bank",
  },
  {
    bank_name: "BANKOFATHENS",
    label: "Bank of Athens",
  },
  {
    bank_name: "AFRICAN",
    label: "African Bank",
  },
  {
    bank_name: "BOE",
    label: "BOE Private Clients",
  },
  {
    bank_name: "BIDVEST",
    label: "Bidvest Bank",
  },
  {
    bank_name: "CITI",
    label: "Citibank",
  },
  {
    bank_name: "GRINDROD",
    label: "Grindrod Bank",
  },
  {
    bank_name: "ABNAMRO",
    label: "ABN AMRO",
  },
  {
    bank_name: "HABIB",
    label: "Habib Overseas Bank",
  },
  {
    bank_name: "HBZ",
    label: "HBZ Bank",
  },
  {
    bank_name: "MEEG",
    label: "Meeg Bank",
  },
  {
    bank_name: "MERCANTILE",
    label: "Mercantile Bank / Capitec Business",
  },
  {
    bank_name: "POSTBANK",
    label: "Postbank",
  },
  {
    bank_name: "TEBA",
    label: "Teba Bank",
  },
  {
    bank_name: "ITHALA",
    label: "Ithala",
  },
  {
    bank_name: "STANDARD_LESOTHO",
    label: "Standard Lesotho Bank",
  },
  {
    bank_name: "STANDARD_SWAZILAND",
    label: "Standard Bank (Swaziland)",
  },
  {
    bank_name: "ALBARAKA",
    label: "Albaraka Bank",
  },
  {
    bank_name: "HSBC",
    label: "HSBC Bank",
  },
  {
    bank_name: "NEDBANKCORP",
    label: "Nedbank Corporate Saver",
  },
  {
    bank_name: "SASFIN",
    label: "Sasfin Bank",
  },
  {
    bank_name: "STATE_BANK_OF_INDIA",
    label: "State Bank of India",
  },
  {
    bank_name: "STANDARD_CHARTERED_BANK",
    label: "Standard Chartered Bank",
  },
  {
    bank_name: "OLYMPUS",
    label: "Olympus Mobile Bank",
  },
  {
    bank_name: "VBS",
    label: "VBS Mutual Bank",
  },
  {
    bank_name: "TYME",
    label: "Tyme Bank",
  },
  {
    bank_name: "GROBANK",
    label: "Grobank",
  },
  {
    bank_name: "DISCOVERY",
    label: "Discovery Bank",
  },
  {
    bank_name: "BANKZERO",
    label: "BankZero Bank",
  },
  {
    bank_name: "GBS_BANK",
    label: "GBS Bank",
  },
];

export const bankBranchCodes = {
  ABSA: "632005",
  AFRICAN: "430000",
  BIDVEST: "462005",
  CAPITEC: "470010",
  DISCOVERY: "679000",
  FNB: "250655",
  INVESTEC: "580105",
  MERCANTILE: "450105",
  NEDBANK: "198765",
  OLDMUTUAL: "462005",
  POSTBANK: "460005",
  SASFIN: "683000",
  STANDARD: "051001",
  TYME: "678910",
  GRINDROD: "223626",
  other: "",
  //   ubank: "431000",
  //   bank_zero: "888000",
  //   al_baraka: "800000",
  //   hbz: "585001",
  //   grobank: "410506",
};

export const predefinedBanks = [
  "absa",
  "fnb",
  "capitec",
  "standard_bank",
  "nedbank",
  "tymebank",
  "discovery",
  "investec",
  "bidvest",
  "mercantile",
];
